import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import ConfirmBooking from './components/form/ConfirmBooking';
import CancelBooking from './components/form/CancelBooking';
import { config } from './lib/config';
import { startResizeBridge } from './lib/resizeBridge';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, staleTime: 60_000, retry: 1 } },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {config.confirmToken ? (
        <ConfirmBooking token={config.confirmToken} />
      ) : config.cancelToken ? (
        <CancelBooking token={config.cancelToken} />
      ) : (
        <App />
      )}
    </QueryClientProvider>
  </StrictMode>,
);

// Height sync to the embedding WordPress page.
startResizeBridge(rootEl);
